import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

export const ITR_skipItrSave_API_CALL = createAsyncThunk(
  'ITR_skipItrSave_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    dispatch({
      type: 'ITR_perfiosOnlineBankreturnUrling_API_CALL/pending',
      payload: {},
    });
    const { skipItrSavePayload, successFn, errorFn, finallyFn } = payload;
    const { customerId, Authorization, customerRefNum, returnUrl, skipReason } =
      skipItrSavePayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      route: 'customerkyc/perfios/skipitr',
      payload: {
        customerRefNum,
        returnUrl,
        requestType: 'ITR_SKIP',
        journeyType: getState().itrJourney.journeyTypeEnum,
        skipITR: true,
        skipReason,
      },
      otherPayloadDetailsPresent: true,
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        dispatch({ type: 'ITR_skipItrSave_API_CALL/fulfilled', payload: res });
        if (successFn) successFn(res);
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'ITR_skipItrSave_API_CALL/rejected', payload: err });
        if (errorFn) errorFn(err);
      },
      finallyFn,
    });
  }
);

export const ITR_skipItrSave_API_CALL_extrareducer = {
  [ITR_skipItrSave_API_CALL.pending]: (state, action) => {
    state.bsVerifyTxnAPICall.isLoading = true;
  },
  [ITR_skipItrSave_API_CALL.fulfilled]: (state, action) => {
    state.bsVerifyTxnAPICall.isLoading = false;
    state.bsVerifyTxnAPICall.isSuccess = true;
    state.bsVerifyTxnAPICall.isError = false;
    state.bsVerifyTxnAPICall.response = action.payload;
  },
  [ITR_skipItrSave_API_CALL.rejected]: (state, action) => {
    state.bsVerifyTxnAPICall.isLoading = false;
    state.bsVerifyTxnAPICall.isSuccess = false;
    state.bsVerifyTxnAPICall.isError = true;
    state.bsVerifyTxnAPICall.response = action.payload;
  },
};
